var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_770_60234)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_770_60234)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_770_60234",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76953 21.39L0.853203 6.52252L15.7207 0.606189L21.637 15.4737L6.76953 21.39Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_770_60234)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_770_60234",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76953 21.39L0.853203 6.52252L15.7207 0.606189L21.637 15.4737L6.76953 21.39Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_770_60234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74479 12.1247C7.91373 14.3805 11.2793 16.6349 16.4532 14.576C16.5453 14.5393 16.6204 14.4693 16.6633 14.3799C16.7063 14.2905 16.7141 14.1882 16.6852 14.0933L16.6731 14.063C16.6381 13.9758 16.5733 13.9039 16.4901 13.8602C16.407 13.8165 16.311 13.8038 16.2194 13.8244C14.5652 14.1756 12.2762 14.3237 10.6059 10.586L12.5882 9.7972C12.6556 9.77026 12.7142 9.72531 12.7577 9.66728C12.8012 9.60924 12.8279 9.54035 12.8349 9.46815C12.8419 9.39594 12.8289 9.32321 12.7973 9.25791C12.7657 9.19262 12.7168 9.13727 12.6558 9.09793L6.53173 5.15712C6.47881 5.12307 6.41853 5.10215 6.3559 5.09609C6.29327 5.09003 6.2301 5.099 6.17163 5.12227C6.11317 5.14553 6.0611 5.18242 6.01976 5.22985C5.97841 5.27729 5.94899 5.33391 5.93393 5.395L4.20005 12.4649C4.1828 12.5354 4.18526 12.6092 4.20717 12.6784C4.22909 12.7475 4.2696 12.8093 4.32428 12.857C4.37896 12.9047 4.4457 12.9364 4.51719 12.9486C4.58869 12.9609 4.66218 12.9533 4.72962 12.9266L6.74479 12.1247Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.957 8.64062C13.1017 8.73375 13.2179 8.86489 13.293 9.01967C13.3681 9.17446 13.3992 9.34693 13.3828 9.51818C13.3663 9.68944 13.3031 9.85287 13.2 9.9906C13.0969 10.1283 12.9579 10.235 12.7982 10.299L11.3505 10.8751C12.7418 13.5778 14.4561 13.6448 16.1097 13.2939C16.3265 13.246 16.5533 13.277 16.7493 13.3812C16.9454 13.4855 17.0978 13.6563 17.1793 13.8628L17.2081 13.9353C17.2754 14.1602 17.2565 14.4021 17.1549 14.6137C17.0533 14.8253 16.8764 14.9914 16.6588 15.0795C14.5368 16.0342 12.1379 16.1757 9.91827 15.4771C9.0262 15.1567 8.20911 14.6572 7.51728 14.0093L9.30426 18.4999C9.41009 18.7658 9.61704 18.979 9.87976 19.0926C10.1425 19.2062 10.4395 19.2111 10.7058 19.1061L19.6089 15.5632C19.8754 15.4571 20.0889 15.2496 20.2023 14.9861C20.3158 14.7227 20.3199 14.425 20.2139 14.1585L16.6695 5.25167C16.5635 4.98518 16.3559 4.77173 16.0925 4.65828C15.8291 4.54483 15.5314 4.54067 15.2649 4.64672L10.0061 6.73937L12.957 8.64062Z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_770_60234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6.76953 21.39) rotate(-111.699)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_770_60234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0014,
    height: 16.0014,
    fill: "white",
    transform: "translate(6.76953 21.39) rotate(-111.699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c5dbeaf833a27355523bf791fff7c080.svg";
export { ForwardRef as ReactComponent };